import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
// import routesAdmin from "./admin";
import routesAdmin from "./admin";
import store from '../store'
import { useCookies } from "vue3-cookies"
import { SETTING_BREAKCRUMB, USER_LOGINED } from '@/const/cookie'
import commons from "@/utils/Common";
const host = window.location.hostname;
const DOMAIN_ADMIN = process.env.VUE_APP_DOMAIN_ADMIN;
const { cookies } = useCookies()
let routes: Array<RouteRecordRaw> = [];

routes = routesAdmin;
const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  let isLoginer = cookies.get(USER_LOGINED)
  // let isLoginer = store.getters.isLoggedIn
  // let isLoginer = commons.getLcUserIsLogin()
  store.dispatch('setBreadcrumb', to.meta.breadcrumb)
  cookies.set(SETTING_BREAKCRUMB, JSON.stringify(to.meta.breadcrumb));
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (isLoginer === 'true') {
      next()
      return
    } else {
      next('/login')
    }
  } else {
    next()
  }
});
export default router;
